import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-light-float')
export class ObiLightFloat extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9 8H15L12.75 4L9 8Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.4351 10.25H8.56457L6.59413 13.6983C5.53042 13.5822 4.61192 13.449 3.88954 13.3304C2.78018 13.1481 2.13333 13 2.13333 13L4.38571 18.5H2V20H9C9 21.6569 10.3431 23 12 23C13.6569 23 15 21.6569 15 20H22V18.5H19.6143L21.8667 13C21.8667 13 21.2198 13.1481 20.1105 13.3304C19.388 13.4491 18.4694 13.5822 17.4055 13.6983L15.4351 10.25ZM14.5987 18.5H17.9934L19.4469 14.9508C19.3675 14.9623 19.2867 14.9739 19.2046 14.9854C17.3759 15.2424 14.8372 15.5 12 15.5C9.16278 15.5 6.62408 15.2424 4.79545 14.9854C4.71326 14.9739 4.63247 14.9623 4.55313 14.9508L6.00662 18.5H9.40135C9.92006 17.6033 10.8896 17 12 17C13.1104 17 14.0799 17.6033 14.5987 18.5ZM15.7653 13.8513L14.5646 11.75H9.43506L8.23432 13.8513C9.39148 13.9408 10.6622 14 12 14C13.3377 14 14.6083 13.9408 15.7653 13.8513ZM13.5 20C13.5 20.8284 12.8284 21.5 12 21.5C11.1716 21.5 10.5 20.8284 10.5 20C10.5 19.1716 11.1716 18.5 12 18.5C12.8284 18.5 13.5 19.1716 13.5 20Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 8H15L12.75 4L9 8Z" style="fill: var(--element-active-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.4351 10.25H8.56457L6.59413 13.6983C5.53042 13.5822 4.61192 13.449 3.88954 13.3304C2.78018 13.1481 2.13333 13 2.13333 13L4.38571 18.5H2V20H9C9 21.6569 10.3431 23 12 23C13.6569 23 15 21.6569 15 20H22V18.5H19.6143L21.8667 13C21.8667 13 21.2198 13.1481 20.1105 13.3304C19.388 13.4491 18.4694 13.5822 17.4055 13.6983L15.4351 10.25ZM14.5987 18.5H17.9934L19.4469 14.9508C19.3675 14.9623 19.2867 14.9739 19.2046 14.9854C17.3759 15.2424 14.8372 15.5 12 15.5C9.16278 15.5 6.62408 15.2424 4.79545 14.9854C4.71326 14.9739 4.63247 14.9623 4.55313 14.9508L6.00662 18.5H9.40135C9.92006 17.6033 10.8896 17 12 17C13.1104 17 14.0799 17.6033 14.5987 18.5ZM15.7653 13.8513L14.5646 11.75H9.43506L8.23432 13.8513C9.39148 13.9408 10.6622 14 12 14C13.3377 14 14.6083 13.9408 15.7653 13.8513ZM13.5 20C13.5 20.8284 12.8284 21.5 12 21.5C11.1716 21.5 10.5 20.8284 10.5 20C10.5 19.1716 11.1716 18.5 12 18.5C12.8284 18.5 13.5 19.1716 13.5 20Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-light-float': ObiLightFloat;
  }
}
